export function isObject(o: any): boolean {
  return Object.prototype.toString.call(o) === "[object Object]";
}

export function deepFindLog(
  element: Element,
  baseAttribute: string,
  extraAttribute: string
) {
  let findBaselog = true;
  let logs: Array<Object> = [];
  let p: Node | Element | null = element;
  while (!!p && p !== document) {
    if (!(p instanceof HTMLElement || p instanceof SVGElement)) {
      p = p.parentNode;
      continue;
    }
    const attributeValue =
      p.getAttribute(findBaselog ? baseAttribute : extraAttribute) || "";
    let obj: Object;

    try {
      obj = JSON.parse(attributeValue);
      if (isObject(obj)) {
        logs.push(obj);
        if (findBaselog) {
          findBaselog = false;
          continue;
        }
      }
    } catch (error) {}
    p = p.parentNode;
  }

  if (logs.length > 0) {
    return logs;
    // return Object.assign({}, ...logs.reverse());
  }
  return null;
}

export function isIntersecting(e: IntersectionObserverEntry) {
  return e.isIntersecting || e.intersectionRatio > 0;
}

export function now() {
  const n = window.performance && performance.now && performance.now();
  return n || Date.now();
}

export function noop() {
  // fix ios 下 click 事件代理无效，需要给 非 body的子节点 添加一个 空 click 事件回调函数
}

export function fixIosClick() {
  for (let i = 0, nodes = document.body.childNodes; i < nodes.length; i++) {
    const node = nodes[i];
    if (
      node instanceof Element &&
      node.nodeType === 1 &&
      !(node as HTMLElement)["onclick"]
    ) {
      (node as HTMLElement)["onclick"] = noop;
    }
  }
}

export function getAttrFrom(e: IntersectionObserverEntry, key: string) {
  return e.target && e.target.getAttribute(key);
}

export function isBrowser() {
  return (
    typeof window !== "undefined" && typeof window.document !== "undefined"
  );
}

// 直接获取element查找的Extra
export function findExtraLog(
  element: Element | null,
  extraAttribute: string = "data-log-extra"
) {
  const logs: Record<string, any>[] = [];
  let p: Node | Element | null = element;
  while (!!p && p !== document) {
    if (!(p instanceof HTMLElement || p instanceof SVGElement)) {
      p = p.parentNode;
      continue;
    }
    const attributeValue = p.getAttribute(extraAttribute) || "";

    try {
      if (attributeValue) {
        const extraLog = JSON.parse(attributeValue);
        logs.unshift(extraLog);
      }
    } catch (error) {
      console.warn("parse json in data-log-extra");
      console.error(error);
    }
    p = p.parentNode;
  }
  return logs.reduce<Record<string, any>>(
    (acc, curr) => ({
      ...acc,
      ...curr,
    }),
    {}
  );
}

/**
 * 获取元素的路径
 * 如#card_26-cartoon_series_1e32d380/section[1]/div[1]/div[1]/div[1]/a[1]/div[3]/div[1]/span[2]
 */
export function getPathByEle(element: HTMLElement | SVGElement): string {
  if (!element) {
    return "";
  }

  if (element.id !== "") return `#${element.id}`;

  if (element === document.body) return "body";

  let ix = 0;

  if (!element.parentNode) {
    return "html";
  }

  const siblings = element.parentNode.childNodes as NodeListOf<
    HTMLElement | SVGElement
  >;

  for (let i = 0, l = siblings.length; i < l; i++) {
    let sibling = siblings[i];

    if (sibling === element)
      return `${getPathByEle(
        element.parentNode as HTMLElement
      )}/${element.tagName.toLowerCase()}${ix > 0 ? `[${ix + 1}]` : ``}`;

    if (sibling.nodeType === 1 && sibling.tagName === element.tagName) {
      ix++;
    }
  }

  return element.tagName.toLowerCase();
}

interface IPlainObj {
  [propName: string]: any;
}

export interface IScope {
  setTags: (tags: IPlainObj) => void;
  setExtras: (info: IPlainObj) => void;
}
// interface ISentry {
//   withScope: (cb: (scope: IScope) => void) => void;
//   captureException: (err: Error) => void;
// }

declare global {
  interface Window {
    Slardar: any;
  }
}

export function isHtmlOrSvg(
  node: Node | null
): node is HTMLElement | SVGAElement {
  if (node === null) {
    return false;
  }
  return (
    node.nodeType === 1 &&
    (node instanceof HTMLElement || node instanceof SVGAElement)
  );
}

export function getClickPositionParams(e: MouseEvent, logs: IPlainObj[] = []) {
  const tgt = e.target as Node;

  if (!window || !isHtmlOrSvg(tgt) || e.type !== "click") {
    return;
  }

  try {
    const { x, y } = e;
    const { left, top } = tgt.getBoundingClientRect();
    const path = getPathByEle(tgt);

    return {
      ele_x: ~~(x - left), // 相对元素x位置
      ele_y: ~~(y - top), // 相对元素y位置
      ele_path: path, // 元素路径
      dw: window.innerWidth,
      dh: window.innerHeight,
    };
  } catch (err) {
    const error_type = "get_click_position_error";

    // 传入当前的log
    const info = Object.assign({}, ...[...logs].reverse());

    const tags = {
      error_type,
    };
    // 目前还没有传入debug选项, 此处还是暴露出去吧
    console.error(err);
    try {
      if (window.Slardar) {
        window.Slardar("Sentry", (Sentry) => {
          Sentry.withScope((scope: IScope) => {
            scope.setTags(tags);
            scope.setExtras(info);
            Sentry.captureException(err);
          });
        });
      }
    } catch (innerErr) {
      console.error("Sentry Error!");
    }
  }
  return null;
}

export function isUndefined(a) {
    return typeof a === 'undefined'
}
export function debounce(func, wait, immediate){
    var timeout, args, context, timestamp, result;
    if (null == wait) wait = 100;
  
    function later() {
      var last = Date.now() - timestamp;
  
      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          context = args = null;
        }
      }
    };
  
    var debounced = function(this: any){
      context = this;
      args = arguments;
      timestamp = Date.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }
      return result;
    };
    return debounced;
  };
  